import {
  getLabelsDataInPrototype,
  getOptionsDataInPrototype,
} from '../../../api/configuratorApi';
import {
  getLabelsDataInPrototypeV2,
  getOptionsDataInPrototypeV2,
} from '../../../api/configuratorApiV2';

export const getSceneLabelOptions = async ({ token, sceneId, storeId }) => {
  let labels = await getLabelsDataInPrototype({
    token,
    sceneId,
    storeId,
    isPublic: true,
  });
  labels = labels?.filter((val) => val.name !== 'default_label');
  for (const val of labels) {
    const textures = await getOptionsDataInPrototype({
      token,
      optionId: val.id,
      storeId,
      isPublic: true,
      page: 1,
      fetchAllPages: true
    });
    val.textures = textures;
  }
  return labels;
};

export const getSceneLabelOptionsV2 = async ({ token, sceneId, storeId }) => {
  let labels = await getLabelsDataInPrototypeV2({
    token,
    sceneId,
    storeId,
    isPublic: true,
  });
  labels = labels?.filter((val) => val.name !== 'default_label');
    await Promise.all(
      labels.map(async (val) => {
        const textures = await getOptionsDataInPrototypeV2({
          token,
          optionId: val.id,
          storeId,
          isPublic: true,
          page: 1,
          fetchAllPages: true,
        });
        val.textures = textures;
        return val;
      })
    );
  // for (const val of labels) {
  //   const textures = await getOptionsDataInPrototypeV2({
  //     token,
  //     optionId: val.id,
  //     storeId,
  //     isPublic: true,
  //     page: 1,
  //     fetchAllPages: true
  //   });
  //   val.textures = textures;
  // }
  // console.log(labels,"labelsss")
  return labels;
};
